/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * PageHeader CSS
 */
export const styles = css`
  :host {
    display: block;
    width: 100%;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .header {
    display: flex;
    flex-direction: column;
    text-align: start;
    font-family: var(--nile-font-family-sans-serif);
    font-style: normal;
  }

  .header__heading {
    display: block;
    color: var(--nile-page-header-heading-font-color);
    font-size: var(--nile-page-header-heading-font-size);
    font-style: normal;
    font-weight: var(--nile-page-header-heading-font-weight);
    line-height: var(--nile-page-header-heading-line-height);
  }

  .header__subheading {
    display: block;
    color: var(--nile-page-header-subheading-font-color);
    font-size: var(--nile-page-header-subheading-font-size);
    font-style: normal;
    font-weight: var(--nile-page-header-subheading-font-weight);
    line-height: var(--nile-page-header-subheading-line-height);
    margin-top: var(--nile-spacing-xs);
  }

  [hidden] {
    display: none;
  }
`;

export default [styles];
